/**
 * Extract a human-readable message from an API error.
 *
 * raasdata-service returns HTTP errors as {"detail": ...} where detail is
 * either an object ({error_code, message, org_id, ...}) or a plain string.
 * The error may be an axios error (body under error.response.data) or the
 * parsed response body itself (XHR upload path in mcapLogsService.upload).
 */
export const getApiErrorMessage = (error, fallback = "Unknown error") => {
  const detail = error?.response?.data?.detail ?? error?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  return error?.response?.data?.message || error?.message || fallback;
};
